import type { ISODateString } from '@/types/string';

export function calculateDuration(startDate: ISODateString, endDate: ISODateString) {
  const arrivalDate = new Date(startDate);
  const departureDate = new Date(endDate);
  const duration = departureDate.getTime() - arrivalDate.getTime();
  const hours = Math.floor(duration / 3600000);
  const minutes = Math.floor((duration % 3600000) / 60000);

  return `${hours}h, ${minutes}m`;
}
